import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from 'components/organisms/Snackbar/useSnackbar'

const useReport = () => {
  const { t } = useTranslation()

  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
      data: null,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error || null,
      }))
    },
    [setState]
  )

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        data: data,
        error: null,
      }))
    },
    [setState]
  )

  // const _fetchInventoryReport = async (from, to) => {
  const _fetchInventoryReport = async (filters) => {
    return await axios.get(`${config.apiBaseUrl}inventory/report`, {
      params: {
        filters,
      },
    })
  }

  const saveReport = useCallback(
    async (
      name,
      filters
      // from,
      //  to
    ) => {
      setStartFetching()

      try {
        const result = await _fetchInventoryReport(filters)
        if (
          result.data.body.hasOwnProperty('success') &&
          result.data.body.success &&
          result.data.body.hasOwnProperty('url')
        ) {
          const link = document.createElement('a')
          link.setAttribute('href', result.data.body.url)
          link.setAttribute('download', `${name}.xlsx`)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setSuccessFetching({ success: result.data.body.success })
        } else {
          setStopFetching()
        }
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopFetching()

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    isFetching: state.isFetching,
    data: state.data,
    error: state.error,
    saveReport,
  }
}

export default useReport
